import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-body-temperature-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './body-temperature-page.component.html',
    styleUrl: './body-temperature-page.component.css',
})
export default class BodyTemperaturePageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Temperatura Corporea';
    chartLabel = 'Temperatura Corporea';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'bar',
        [HealthChartPeriod.month]: 'bar',
    }
    heightHealthDataType = HealthDataType.BODY_TEMPERATURE;
    hasTwoDecimals = true;
    payloadTypes: dataType[] = ['body'];

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
